<div *ngFor="let item of items">
  <lib-content-loader [component]="item"></lib-content-loader>
</div>
